export const MANAGER_OR_HIGHER_POSITIONS = [
    'Territory Manager',
    'Business Manager',
    'Senior Outlet Manager',
    'Outlet Manager',
];

export const isManagerOrHigher = (position) =>
    MANAGER_OR_HIGHER_POSITIONS.includes(position);

export const getAvailablePages = (position) => {
    const pages = [
        'inventory',
        'packing',
        'cooking',
        'insta-service',
        'attendance-scan',
        'all-orders',
        'hub-performance',
        'operation-dashboard',
    ];

    if (position === 'Territory Manager') {
        pages.push('outlet-open-close-control');
    }

    if (isManagerOrHigher(position)) {
        pages.push('partner-management');
    }

    return pages;
};

export const getPageLabel = (page) => {
    if (page === 'outlet-open-close-control') {
        return 'Outlet Open/Close Control';
    }

    if (page === 'hub-performance') {
        return 'Performance';
    }

    return page;
};
